// extracted by mini-css-extract-plugin
module.exports = {"TypeWritter":"TypeWritter_TypeWritter__2qVQZ"};